import { Pipe, PipeTransform } from '@angular/core';
import { SearchService } from 'src/app/modules/motores/vuelos/services/search.service';

@Pipe({
    name: 'currencyExchange'
})
export class CurrencyExchangePipe implements PipeTransform {
    public objectMoneda: any = [];
    constructor(
        private _searchService: SearchService
    ){
        this.obtenerValorDolarPeso();
    }

    obtenerValorDolarPeso(){
      const date = new Date()
      const formatted_date = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
      let tipoDeCambio = localStorage.getItem('exchangeRateActual'+formatted_date);
      if(tipoDeCambio!=undefined&&tipoDeCambio!=null&&tipoDeCambio!=""){
        this.objectMoneda=JSON.parse(tipoDeCambio)
      }else{
        this._searchService.getExchangeRates().subscribe(res => {
          localStorage.setItem('exchangeRateActual'+formatted_date, JSON.stringify(res['data'].exchangeRateElement));
            this.objectMoneda = res['data'].exchangeRateElement;
        });
      }
      }

    transform(value: any, checkedCurrency, concatCurrency = true) {
        if (typeof value === "string") {
            value = parseFloat(value);
          }
              if (!checkedCurrency) {
                return this.numberWithCommas(value.toFixed(2));
              }else{
                let valor = ((value.toFixed(2))/this.objectMoneda[0].rate);
                return this.numberWithCommas(valor.toFixed(2));
              }
        
    }
    numberWithCommas(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }
}
